export function getStatusColor(
  status: string | boolean | number | null | undefined,
): string {
  // Handle null/undefined
  if (status === null || status === undefined) {
    return '#526ED3'; // info/blue
  }

  // Handle boolean values (e.g., domain status: true = active, false = inactive)
  if (typeof status === 'boolean') {
    return status ? '#39B54A' : '#79818C'; // success/green : neutral/gray
  }

  // Handle number values
  if (typeof status === 'number') {
    return '#526ED3'; // info/blue
  }

  // Ensure it's a string and normalize
  if (typeof status !== 'string') {
    return '#526ED3'; // info/blue
  }

  const normalized = status.toLowerCase();

  const warningStatuses = [
    'pending',
    'pending_cash_out',
    'scheduled',
    'withheld',
    'in_dispute',
    'pending_refund',
    'postpaid',
    'prepaid',
  ];

  const successStatuses = [
    'paid',
    'confirmed',
    'success',
    'cashed_out',
    'active',
    'fixed',
  ];

  const dangerStatuses = [
    'failed',
    'canceled',
    'rejected',
    'expired',
    'past_due',
  ];

  const secondaryStatuses = ['refunded', 'variable'];

  if (warningStatuses.includes(normalized)) {
    return '#FFD54F'; // warning/yellow
  }

  if (successStatuses.includes(normalized)) {
    return '#39B54A'; // success/green
  }

  if (dangerStatuses.includes(normalized)) {
    return '#FF7043'; // error/red
  }

  if (secondaryStatuses.includes(normalized)) {
    return '#79818C'; // neutral/gray
  }

  return '#526ED3'; // info/blue - fallback/default
}
